import { BACKGROUND_ASSET_DESKTOP, BACKGROUND_ASSET_MOBILE } from '../elements/assets'
import { LINK_TITLE, BUTTON_SETTINGS } from '../elements/link'

export const HERO_FEATURE_COLUMNS = `
...on heroFeatureColumns_Entry {
  id
  typeHandle
  
  headingAdvanced {
    html
  }
  description

  ${ LINK_TITLE }
  ${ BUTTON_SETTINGS }

  featureColumns {
    id
    label
    title
    description
  }

  ${ BACKGROUND_ASSET_DESKTOP }
  ${ BACKGROUND_ASSET_MOBILE }
}
`